import './acknowledgement.scss';
import {useQueryAcknowledgementInfo} from "../../../../api/cpl-applicant/useQueryAcknowledgementInfo";
import {useQueryAcknowledgement} from "../../../../api/cpl-applicant/useQueryAcknowledgement";
import {useContext, useEffect, useState} from "react";
import {PortfolioContext} from "../../../../hooks/Context/PortfolioContext";
import AlertModal from "../../../../components/UI/Modals/AlertModal/AlertModal";
import Checkbox from "../../../../components/UI/Checkbox/Checkbox";
import {toast} from "react-toastify";
import {useMutateAcknowledgement} from "../../../../api/cpl-applicant/useMutateAcknowledgement";

const Acknowledgement = () => {
  const [portfolio] = useContext(PortfolioContext);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);

  const {data: acknowledgementInfo} = useQueryAcknowledgementInfo();
  console.log('acknowledgementInfo', acknowledgementInfo)

  const {error} = useQueryAcknowledgement({
    portfolio_id: portfolio.id,
    institution_message_id: acknowledgementInfo?.institution_message_id
  });

  const {mutate} = useMutateAcknowledgement();

  const submitAcknowledgement = () => {
    if (toggle) {
      mutate({
        portfolio_id: portfolio.id,
        institution_message_id: acknowledgementInfo?.institution_message_id
      });
      setShowModal(false);
    } else {
      toast.warning('Please read and accept PLAR limitations.')
    }
  }

  const modalFooter = () => <div className={'acknowledgement-footer'}>
    <Checkbox
      handleClick={() => setToggle(!toggle)}
      active={toggle}
      textHtml={"I have read and understood the PLAR application limitations."}
    />
    <div className={'acknowledgement-footer-divider'}/>
  </div>

  useEffect(() => {
    if (acknowledgementInfo?.message && error) {
      setShowModal(true);
    }
  }, [acknowledgementInfo, error])


  return <div className={'acknowledgement'}>
    <AlertModal
      open={showModal}
      onClose={() => toast.warning('Please read and accept PLAR limitations.')}
      onProceed={submitAcknowledgement}
      proceedText={"Continue"}
      title={"Important information"}
      text={acknowledgementInfo?.message}
      additionalBody={modalFooter()}
      disableClosing
      className={'acknowledgement-modal'}
    />
  </div>
}

export default Acknowledgement;